import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

export default function requireAuthentication(Component) {
  class AuthenticatedComponent extends React.Component {
    render() {
      // if the user is not authenticated, redirect to login page (/)
      return (
        <div>
          {this.props.isAuthenticated === true ? (
            <Component {...this.props} />
          ) : (
            <Redirect to="/" />
          )}
        </div>
      );
    }
  }

  const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.user != null,
  });

  return connect(mapStateToProps)(AuthenticatedComponent);
}



// WEBPACK FOOTER //
// ./src/HOC/requireAuthentication.js